import script from "./addHours.vue?vue&type=script&lang=js"
export * from "./addHours.vue?vue&type=script&lang=js"

import "./addHours.vue?vue&type=style&index=0&id=04c64a8e&lang=css"
import "./addHours.vue?vue&type=style&index=1&id=04c64a8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04c64a8e"]])

export default __exports__